import { createSlice } from "@reduxjs/toolkit";
import { TPopupVariantTypes } from "Components/Elements/DialogModal";
import {
  countryList,
  currencyList,
  ROLE,
  segmentSolution,
  STATUS,
} from "Components/Misc/CaseDetails_System";
import setObj from "lodash/set";
import { setProp } from "Store/Actions/index";
import { setPropT } from "Store/Actions/ts/index";
// import { setProp } from "./Actions";
// import { setPropT } from "./Actions/ts";
const initialSystemData = {
  isLoading: false,
  isBoqLoading : false,
  isAddProductLoaded : {status : 'false',showField:[]},
  // Used to show the loader when the user is logging in
  isAuthLoading: false,
  // Is user authorized to access the page
  isAuthorized: undefined,  
  currentState: {
    fieldsRequired: {
      distributor: false,
      indirect_resellers: false,
      resellers: false,
      endCustomer: false,
    },
    allowedComp: {
      form: [],
    },
    caseType: "",
    //authSelector.currentState.allowedComp.form
  },
  segmentSolution: segmentSolution,
  configuratorSolution: [],
  countryList: countryList,
  caseTypes: [
    { id: "new", name: "New Case" },
    {
      id: "addition_to_existing_edge",
      name: "Addition to Exisiting Network",
    },
    { id: "non_commercial_network", name: "Non-Commertial (Demo/Lab)" },
    { id: "internal_order", name: "Internal" },
    { id: "demand_forecast", name: "Demand Forecast" },
    { id: "frame_agreement", name: "Frame Agreements or Commitments" },
  ],
  currencyList: currencyList,
  account: [],
  endCustomer: [],
  resellers: [],
  indirect_resellers: [],
  distributor: [],
  networkids: [],
  stack: {
    success: [],
    warn: [],
    error: [],
    info:[],
    snack:[],
  },
  popup: {
    msg: "", show: false,
  },
  modal: {
    msg: "",
    show: false,
    variant: "CONFIRM" as TPopupVariantTypes,
    action: [
    ],
    panel: {
      msg: '',
      title: '',
    },
    title: ""
  }
};

const initialOOTData = {
  status: STATUS.HIDE,
  auth: {
    token: "1c1718326c211058c2e9ae4cd2013115dfa9c0f5c9e8c9e8799b51f10ecdd8d9",
    secret: "e8428fbd69aefdf59f016431176984f8f9a18de6f350b5c10b68722a4c84d77f",
    userId: 20751,
  },
  data: {
    sales_channel: null,
    market: null,
    currency: null,
    currency_check : false,
    end_customer: {
      name: ""
    },
    case_name: "",
    networkids: []
  },
};

const initialData = {
  role: ROLE.INTERNAL,
  tester: false, //A tester can swap b/w roles
  login: {
    displayName: "..",
    adToken: null,
    mail: ""
  },
  system: initialSystemData,
  OOT: initialOOTData,
  status: STATUS.IDLE,
  userDatamart_role: '',
  isUserApprover: false,
  // Is offer data is restored from dashboard
  isOfferDataRestored: false,
  offer_owner_email:""
};

const authSlice = createSlice({
  name: "authSlice",
  initialState: initialData,
  reducers: {
    showPopup(state, action) {
      //{msg:"",show:bool}
      state.system.popup.msg = action.payload.msg;
      state.system.popup.show = action.payload.show;
    },
    showModal(state, action) {

      //{msg:"",show:bool}
      state.system.modal.msg = action.payload.msg;
      state.system.modal.title = action.payload.title;
      state.system.modal.show = action.payload.show;
      state.system.modal.variant = action.payload.variant;
      if (action.payload.hasOwnProperty('panel')) {
        state.system.modal.panel.msg = action.payload.panel.msg;
        state.system.modal.panel.title = action.payload.panel.title;
      }
      if (action.payload.hasOwnProperty('action')) {
        /*
        Contains [] of {show: false,text: "",func: ""}
        */
        state.system.modal.action = action.payload.action
      }

    },

    changeAppState(state, action) {
      //const found ={...action.payload}
      state.system.currentState = action.payload;
    },
    showLoader(state, action) {
      state.system.isLoading = action.payload;
    },
    showBoqLoader(state, action) {
      state.system.isBoqLoading = action.payload;
    },
    setAddProductLoader(state, action) {
      state.system.isAddProductLoaded = action.payload;
    },
    // Used to show the loader when the user is logging in
    showAuthLoader(state, action) {
      state.system.isAuthLoading = action.payload;
    },
    // Set user authorization status
    setUserAuthorization(state, action) {
      state.system.isAuthorized = action.payload;
    },
    resetAuth(state) {
      // state.status = STATUS.HIDE;
      state.OOT.data["case_name"] = ""; //makes the loadedTool == 'None';
      delete state.OOT.data["case_name"];
      //state.OOT = initialOOTData;
      state.system = initialSystemData;
      state.OOT.status = STATUS.HIDE;
    },
    setOOTAuth(state, action) {
      // state.OOT.auth = action.payload;
      state.OOT.data = action.payload;
    },
    setOOTStatus(state, action) {
      state.OOT.status = action.payload;
    },
    setendCustomer(state, action) {
      state.system.endCustomer = action.payload;
    },
    setNetworkIds(state, action) {
      state.system.networkids = action.payload;
    },
    setAccount(state, action) {
      state.system.account = action.payload;
    },
    setRole(state, action) {
      state.role = action.payload;
    },
    setUser(state, action) {
      if (action.payload) {
        state.login = action.payload;
        state.login.adToken = JSON.parse(action.payload.adToken);

        if (/.*@(nokia.com|nokia-bell-labs.com|nokia-sbell.com)$/.test(action.payload.mail)) {
          state.role = ROLE.INTERNAL; //default : internal
        } else {
          state.role = ROLE.PARTNER;
        }

      } else {
        state.system.stack.warn.push({
          errorMsg: "Synchronizing User",
          errorCode: null,
        });
      }
    },
    setConfigSegmentSoln(state, action) {
      state.system.configuratorSolution = action.payload;
    },
    patchToken(state, action) {
      state.login.adToken.idToken = "";
      state.login.adToken.idToken = action.payload.id_token;
      state.login.adToken.accessToken = "";
      state.login.adToken.accessToken = action.payload.access_token;
    },
    updateAccount(state, action) {
      if (action.payload.type === "account") {
        state.system.account.push(action.payload);
      }
      if (action.payload.type === "end_customer") {
        state.system.endCustomer.push(action.payload);
      }
      if (action.payload.type === "resellers") {
        // alert('updated')
        state.system.resellers.push(action.payload);
      }
      if (action.payload.type === "indirect_resellers") {
        state.system.indirect_resellers.push(action.payload);
      }
      if (action.payload.type === "distributor") {
        state.system.distributor.push(action.payload);
      }
    },
    setError(state, action) {
      if (["success","error", "warn","info"].includes(action.payload.key)) {
        //isExist === undefined
        state.system.stack.success = [];
        state.system.stack.error = [];
        state.system.stack.warn = [];
        state.system.stack.info = [];
        console.log("setError", action.payload);
        state.system.stack[action.payload.key].push(action.payload.value);
      }
      if (action.payload === "reset") {
        state.system.stack.success = [];
        state.system.stack.error = [];
        state.system.stack.warn = [];
        state.system.stack.info = [];
      }
    },
    setSnackMessage(state, action) {
      if (action.payload.key === "add_snack") {
        // state.system.stack.snack = action.payload.value;
        state.system.stack.snack.push(action.payload.value);
      }
      if (action.payload.key === "update_snack") {
        state.system.stack.snack = action.payload.value;        
      }
      if (action.payload === "reset_snack") {
        state.system.stack.snack = [];
      }
    },
    setDatamartUserRole(state, action) {
      state.userDatamart_role = action.payload.datamartRole;
      state.isUserApprover = action.payload.isApprover;
    },
    // Reset the validation messages for the given key
    resetValidationMessages(state, action) {
      if (["success","error","warn","info"].includes(action.payload.key)) {
        state.system.stack[action.payload.key] = [];
      }
    },
    setValidationMessages(state, action) {
      if (["success","error", "warn","info"].includes(action.payload.key)) {
        state.system.stack[action.payload.key].push(action.payload.value);
      }
    },
    silentLogin(state, action) { },
    handleSellToParty(state, action) {

      state.system.account = action.payload;
      state.system.distributor = action.payload;
      state.system.indirect_resellers = action.payload;
      state.system.resellers = action.payload;
    },
    // Used to set the offer data restored from dashboard
    setStateRestoreFlag(state, action) {
      state.isOfferDataRestored = action?.payload?.isOfferDataRestored ? action.payload.isOfferDataRestored : false;
      state.offer_owner_email = action?.payload?.owner_email ? action.payload.owner_email : false;
    }
  },
  extraReducers(builder) {
    builder.addCase(setProp, (state, action: setPropT) => {
      if (action.payload.slice === authSlice.name) {
        setObj(state, action.payload.key, action.payload.value);
      }
    })
  }
});

export default authSlice.reducer;

export const {
  setOOTAuth,
  showLoader,
  showBoqLoader,
  setAddProductLoader,
  // Used to show the loader when the user is logging in
  showAuthLoader,
  // Set user authorization status
  setUserAuthorization,
  setUser,
  setRole,
  patchToken,
  setError,
  setOOTStatus,
  resetAuth,
  updateAccount,
  setendCustomer,
  setAccount,
  changeAppState,
  showPopup,
  showModal,
  handleSellToParty,
  setNetworkIds,
  setConfigSegmentSoln,
  setValidationMessages,
  resetValidationMessages,
  setDatamartUserRole,
  setStateRestoreFlag,
  setSnackMessage,
} = window['authSlice'] = authSlice.actions;
